export const CancelOfferInvalidParametersError: Error = new Error('Invalid parameters for cancelling an offer');
export const CancelOfferTokensListError: Error = new Error('Failed to retrieve tokens list from api');
export const CancelOfferAssetError: Error = new Error('Failed to retrieve asset from api');
export const CancelOfferOrderError: Error = new Error('Failed to retrieve order from api');
export const CancelOfferCancelOrderAPIError: Error = new Error('Failed to cancel offer in api');
